import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = () => ({
  root: {},
});

const LinkStatusIndicatorIcon = ({
  className,
  classes,
  fill,
}) => {
  return (
    <Icon
      className={classNames(classes.root, className)}
      fill={fill}
      icon={CheckCircleIcon}
      fontSize={'small'}
    />
  );
};

LinkStatusIndicatorIcon.defaultProps = {
  className: '',
};

LinkStatusIndicatorIcon.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  fill: PropTypes.string.isRequired,
};

export default withStyles(styles)(LinkStatusIndicatorIcon);
